import { environment } from '@env/environment';
import { SOLE_PROP_DOCUMENTS_MAPPER } from '@shared/config/sole-prop-documents';
import { PARTNER_DOCUMENTS_MAPPER } from '@shared/config/partnership-documents';
import { COMPANY_DOCUMENTS_MAPPER } from '@shared/config/company-documents';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "@angular/router";
export class BilUploadDocumentsService {
    constructor(http, router) {
        this.http = http;
        this.router = router;
        this.isOperationalAddressChecked = false;
    }
    /**
     * @method flowCheck
     * @param  void
     * @return {}
     */
    flowCheck() {
        let identificationData = String(localStorage.getItem('pan/gst'));
        return this.flowUploadDocumentMap(identificationData);
    }
    getFourthCharacter() {
        return String(localStorage.getItem('pan/gst'));
    }
    flowUploadDocumentMap(character) {
        switch (character.toUpperCase()) {
            case 'P':
                return SOLE_PROP_DOCUMENTS_MAPPER;
            case 'F':
                return PARTNER_DOCUMENTS_MAPPER;
            case 'C':
                return COMPANY_DOCUMENTS_MAPPER;
            default:
        }
    }
    getIsOperationalAddrCheckedStatus() {
        return this.isOperationalAddressChecked;
    }
    setIsOperationalAddrCheckedStatus(status) {
        this.isOperationalAddressChecked = status;
    }
    /**
     * @method submitITR
     * @param  {} reqBody
     * @return ITRResponse
     */
    submitITR(reqBody) {
        return this.http.post(environment.basePath + '/uploadItr', reqBody);
    }
    /**
     * @method submitITR
     * @param  {} reqBody
     * @return ITRResponse
     */
    updateItrStage(reqBody) {
        return this.http.post(environment.basePath + '/updateOrDeleteStage', reqBody);
    }
    deleteITR(reqBody) {
        return this.http.post(environment.basePath + '/deleteItr', reqBody);
    }
    getDeleteThresholdITR() {
        return this.http.get(environment.basePath + '/getDeleteThresholdITR');
    }
    /**
     * @method proprietorAddress
     * @param void
     * @return doc list for registration proof in sole prop journey
     */
    proprietorAddress() {
        return this.http.get(environment.basePath + '/kyc/address/PROPRIETOR_ADDRESS');
    }
    proprietorBusiness() {
        return this.http.get(environment.basePath + '/kyc/address/PROPRIETOR_BUSINESS');
    }
    getBanks() {
        return this.http.get(environment.basePath + '/bs/banks');
    }
    getStatus() {
        return this.http.get(environment.basePath + '/bs/status/v1');
    }
    uplaodBankStatement(data) {
        return this.http.post(environment.basePath + '/bs/upload/s3/v1', data);
    }
    deleteBankStatement(data) {
        return this.http.post(environment.basePath + '/bs/delete/s3/v1', data);
    }
    submitToPerfios() {
        return this.http.post(environment.basePath + '/bs/upload/perfios/v1', {});
    }
    getDocumentUploadedStatus() {
        return this.http.get(environment.basePath + '/bil-document');
    }
    /**
    * @method handleBack
    * @param void
    * @return void
    */
    handleBack() {
        this.router.navigate(['/bil/upload-document']);
    }
    /**
   * @method ownerKYC
   * @param void
   * @return void
   */
    ownerKyc(reqBody) {
        return this.http.post(environment.basePath + '/kyc/v2/owner/id', reqBody);
    }
    /**
  * @method companyKYC
  * @param void
  * @return void
  */
    companyKYC(reqBody) {
        return this.http.post(environment.basePath + '/kyc/v2/entity/id', reqBody);
    }
    /**
  * @method getStackeHolder
  * @param void
  * @return void
  */
    getStakeHolder() {
        return this.http.get(environment.basePath + `/getPartners`);
    }
    /**
  * @method postRegistrationProof
  * @param void
  * @return post registration proof
  */
    postRegistrationProof(requestBody) {
        return this.http.post(environment.basePath + '/kyc/businessProofKYC', requestBody);
    }
    applicationSubmission() {
        return this.http.put(environment.basePath + '/stage', {});
    }
    initiatePayLaterRequest(requsestBody) {
        return this.http.post(environment.basePath + '/invoiceFinancing/v1/activation', requsestBody);
    }
    /**
    * @method deletePartner
    * @param void
    * @return post Partnership and company flow
    */
    removePartners(id) {
        return this.http.put(environment.basePath + '/deactivate-stakeholder/' + id, {});
    }
    /**
    * @method PARTNERSHIP_ADDRESS
    * @param void
    * @return GET Partnership flow
    */
    partnerShipAddress() {
        return this.http.get(environment.basePath + '/kyc/address/PARTNERSHIP_ADDRESS');
    }
    /**
    * @method partnerShipBusiness
    * @param void
    * @return GET Partnership flow
    */
    partnerShipBusiness() {
        return this.http.get(environment.basePath + '/kyc/address/PARTNERSHIP_BUSINESS');
    }
    /**
    * @method Company_ADDRESS
    * @param void
    * @return GET company flow
    */
    companyAddress() {
        return this.http.get(environment.basePath + '/kyc/address/COMPANY_ADDRESS');
    }
    /**
    * @method Company_BUSINESS
    * @param void
    * @return GET company flow
    */
    companyBusiness() {
        return this.http.get(environment.basePath + '/kyc/address/COMPANY_BUSINESS');
    }
    registrationProofBuisnessList() {
        let character = this.getFourthCharacter();
        let url;
        if (character.toUpperCase() == 'P') {
            url = environment.basePath + '/kyc/address/PROPRIETOR_BUSINESS';
        }
        else if (character.toUpperCase() == 'F') {
            url = environment.basePath + '/kyc/address/PARTNERSHIP_BUSINESS';
        }
        else if (character.toUpperCase() == 'C') {
            url = environment.basePath + '/kyc/address/COMPANY_BUSINESS';
        }
        return this.http.get(url);
    }
    /**
    * @method CompanyRegistrationProof
    * @param void
    * @return GET company flow
    */
    uploadedDocuments() {
        return this.http.post(environment.basePath + '/docs/document-uploaded-status', {});
    }
    /**
     * @method CompanyRegistrationProof
     * @param void
     * @return Post company flow
     */
    moaUpload(data) {
        return this.http.post(environment.basePath + '/mcadocupload/moa', data);
    }
    aoaUpload(data) {
        return this.http.post(environment.basePath + '/mcadocupload/aoa', data);
    }
    cocUpload(data) {
        return this.http.post(environment.basePath + '/mcadocupload/coicoc', data);
    }
    mcaDocUpload(data, isDocUploadedCoi) {
        return this.http.post(environment.basePath + '/mcadocupload/' + isDocUploadedCoi, data);
    }
    updateStage() {
        return this.http.put(environment.basePath + '/kyc/v2/owner/stage', {});
    }
    getYearDetails() {
        return this.http.get(environment.basePath + '/fsa/years');
    }
    getNumOfItrs() {
        return this.http.get(environment.basePath + '/getNumOfItrs');
    }
    // operational address api
    getState() {
        return this.http.get(environment.basePath + '/state/ACTIVE');
    }
    getAddressDetails() {
        return this.http.get(environment.basePath + '/getAddress/v1');
    }
    getOperationalAddressFromCustomer() {
        return this.http.get(environment.basePath + '/address/operational/v1');
    }
    getOperationalAddress() {
        let FourthCharacter = this.getFourthCharacter();
        if (FourthCharacter.toUpperCase() == 'F') {
            return this.http.get(environment.basePath + '/kyc/address/PARTNERSHIP_OPERATIONAL_ADDRESS');
        }
        else if (FourthCharacter.toUpperCase() == 'C') {
            return this.http.get(environment.basePath + '/kyc/address/COMPANY_OPERATIONAL_ADDRESS');
        }
        else if (FourthCharacter.toUpperCase() == 'P') {
            return this.http.get(environment.basePath + '/kyc/address/PROPRIETOR_OPERATIONAL_ADDRESS');
        }
    }
    saveOperationalAddress(requestBody) {
        return this.http.post(environment.basePath + '/saveAddress/v1', requestBody);
    }
    submitRegistrationProofAsOperationalAddress() {
        return this.http.post(environment.basePath + '/kyc/dateOfIncorp', { 'operation_adds_status': true });
    }
}
BilUploadDocumentsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function BilUploadDocumentsService_Factory() { return new BilUploadDocumentsService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.Router)); }, token: BilUploadDocumentsService, providedIn: "root" });
